// React
import React from 'react';
import classNames from 'classnames';
// Components
import Conditional from '../conditional';
import CustomReadOnlyHourInterval from './../custom-read-only-hour-interval';
//Styles
import useStyles from './CustomReadOnlyHourIntervalList.styles';

const CustomReadOnlyHourIntervalList = ({ classes, intervals }) => {
  const componentClasses = useStyles();
  return (
    <div className={classNames(componentClasses.root)}>
      <Conditional if={!intervals || intervals.length === 0}>
        <CustomReadOnlyHourInterval />
      </Conditional>
      <Conditional if={intervals.length > 0}>
        <div className={componentClasses.intervalsContainer}>
          {intervals.map((interval, index) => (
            <CustomReadOnlyHourInterval
              key={`intervals-${index}`}
              open={interval.starts_time}
              close={interval.ends_time}
            />
          ))}
        </div>
      </Conditional>
    </div>
  );
};

CustomReadOnlyHourIntervalList.defaultProps = {
  classes: {},
  intervals: [],
};

export default CustomReadOnlyHourIntervalList;
